import { gql } from '@apollo/client'

export const GET_MY_HOLE_IN_ONES = gql`
  query MyHoleInOnes {
    myHoleInOnes {
      id
      golferName
      courseName
      occurredAt
      holeNumber
      holePar
      yardage
      publicVisibility
      status
    }
  }
`
